import { ref } from 'vue'

import { LS_KEY } from '@/utils/constants'
import { decrypt, encrypt } from '@/utils/crypto.ts'

const storage = ref<{ [T: string]: any }>({})

const setItem = (key: string, payload: any): void => {
  const lsKey = `${LS_KEY}${key}`
  storage.value[lsKey] = payload
  try {
    const value = import.meta.env.PROD ? encrypt(JSON.stringify(payload)) : JSON.stringify(payload)
    localStorage.setItem(lsKey, value)
  } catch (e) {
    console.error('Error setting item in localStorage:', e)
  }
}

const getItem = (key: string): any => {
  const lsKey = `${LS_KEY}${key}`
  let item = storage.value[lsKey]
  if (item === undefined) {
    const val = localStorage.getItem(lsKey)
    if (!val) return null
    try {
      item = JSON.parse(import.meta.env.PROD ? decrypt(val) : val)
      storage.value[lsKey] = item
    } catch {
      return null
    }
  }
  return item
}

const removeItem = (key: string): void => {
  const lsKey = `${LS_KEY}${key}`
  delete storage.value[lsKey]
  localStorage.removeItem(lsKey)
}

const clear = () => {
  storage.value = {}
  localStorage.clear()
}

export function useLsStorage() {
  return {
    storage,
    setItem,
    getItem,
    removeItem,
    clear,
  }
}
